import React, { Fragment, useEffect, useState } from 'react';
import VisitorsAnalytics from 'apis/rest/VisitorsAnalytics';
import { getLivePages } from 'apis/rest/livestream/GetLivePages';
import './visits.scss';
import PageSpinner from 'components/app/common/pageSpinner';
import {
    Select,
    DatePicker,
    Tooltip,
    Divider,
    Button,
    Modal,
    Pagination,
} from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Table } from 'react-bootstrap';
import FileSaver from 'file-saver';
// import ReactPaginate from 'react-paginate';
import moment from 'moment';
import momentTimezone from 'moment-timezone';

import { debounce, uniqBy, isEmpty } from 'lodash';

const DownloadClicksList = ({
    enabledVenue,
    projectId,
    livePageId,
    startDate,
    endDate,
    isExportVisible,
    enableExport,
}) => {
    const [DownloadData, setDownloads] = useState([]);
    const [downloadsDataLoading, setDownloadsDataLoading] = useState(false);
    const [eventAction, setEventAction] = useState('');
    const [eventName, setEventName] = useState('');
    const [pageData, setPagination] = useState({});
    const [detailUserData, setDetailUserData] = useState([]);
    const [detailUserDataLoading, setDetailUserDataLoading] = useState(true);
    const [modalVisibility, setModalVisibility] = useState(false);

    const getFetchUserData = async (
        category = 'Download',
        eventAction,
        eventName
    ) => {
        setEventAction(eventAction);
        setEventName(eventName);
        setDetailUserDataLoading(true);
        try {
            let { status, matomo } = await VisitorsAnalytics.getClickDetail(
                category,
                projectId,
                livePageId,
                moment(startDate).format('YYYY-MM-DD'),
                moment(endDate).format('YYYY-MM-DD'),
                eventAction,
                eventName,
                false
            );
            if (status && matomo && matomo.users && matomo.users.length > 0) {
                setDetailUserData(matomo.users);
                setDetailUserDataLoading(false);
            } else {
                setDetailUserData([]);
                setDetailUserDataLoading(false);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const exportFetchUserData = async (category = 'Download') => {
        try {
            if (!isExporting) {
                setExporting(true);
                const response = await VisitorsAnalytics.getClickDetail(
                    category,
                    projectId,
                    livePageId,
                    moment(startDate).format('YYYY-MM-DD'),
                    moment(endDate).format('YYYY-MM-DD'),
                    eventAction,
                    eventName,
                    true
                );
                FileSaver.saveAs(response, `DownloadUsers.csv`);
                setExporting(false);
            }
        } catch (error) {
            console.error(error);
            setExporting(false);
        }
    };

    const getDownloads = async (selPage = 1) => {
        setDownloadsDataLoading(true);
        try {
            let { status, matomo, pagination } =
                await VisitorsAnalytics.getDownloadClicks(
                    projectId,
                    livePageId,
                    moment(startDate).format('YYYY-MM-DD'),
                    moment(endDate).format('YYYY-MM-DD'),
                    false,
                    selPage
                );
            if (
                status &&
                matomo &&
                matomo.downloads &&
                matomo.downloads.length > 0
            ) {
                setDownloads(matomo.downloads);
                if (pagination) setPagination(pagination);
                if (!isExportVisible) enableExport();
            } else setDownloads([]);
        } catch (error) {
            console.error(error);
        } finally {
            setDownloadsDataLoading(false);
        }
    };
    const [isExporting, setExporting] = useState(false);
    const exportDownloadData = async () => {
        try {
            if (!isExporting) {
                setExporting(true);
                const response = await VisitorsAnalytics.getDownloadClicks(
                    projectId,
                    livePageId,
                    moment(startDate).format('YYYY-MM-DD'),
                    moment(endDate).format('YYYY-MM-DD'),
                    true
                );
                FileSaver.saveAs(response, `${livePageId}DownloadClicks.csv`);
                setExporting(false);
            }
        } catch (error) {
            console.error(error);
            setExporting(false);
        }
    };
    const { totalPage, currentPage } = pageData;
    useEffect(() => {
        if (livePageId && startDate && endDate) {
            getDownloads();
        }
    }, [livePageId, startDate, endDate]);
    return (
        <>
            {DownloadData.length > 0 ? (
                <div className="visitorsCard">
                    <div className="visitorsTable">
                        <div
                            style={{
                                fontFamily: "'Open Sans'",
                                fontSize: '18px',
                                fontWeight: 'bold',
                                padding: '20px',
                                marginBottom: '-80px',
                            }}
                        >
                            What files did visitors download?
                        </div>
                        <Table borderless hover size="sm" responsive>
                            <thead>
                                <tr>
                                    {/* <th>Label</th> */}
                                    <th>Url</th>
                                    <th>Total Clicks</th>
                                </tr>
                            </thead>
                            <tbody>
                                {DownloadData.map(
                                    (
                                        {
                                            Events_EventAction,
                                            Events_EventName,
                                            nb_events,
                                        },
                                        index
                                    ) => {
                                        return (
                                            <tr
                                                key={index + Events_EventAction}
                                            >
                                                {/* <td>
                                                    {Events_EventAction ?? 'NA'}
                                                </td> */}
                                                <td>
                                                    {Events_EventName ?? 'NA'}
                                                </td>

                                                <td>
                                                    {nb_events > 0 ? (
                                                        <a
                                                            style={{
                                                                color: 'blue',
                                                                textDecoration:
                                                                    'underline',
                                                            }}
                                                            onClick={() => {
                                                                getFetchUserData(
                                                                    'Download',
                                                                    Events_EventAction,
                                                                    Events_EventName
                                                                );
                                                                setModalVisibility(
                                                                    true
                                                                );
                                                            }}
                                                        >
                                                            {nb_events ?? '0'}
                                                        </a>
                                                    ) : (
                                                        nb_events ?? '0'
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    }
                                )}
                            </tbody>
                        </Table>
                        {totalPage && totalPage > 1 && (
                            <div className="paginationBar">
                                {/* <ReactPaginate
                                    previousLabel="prev"
                                    nextLabel="next"
                                    breakLabel="..."
                                    breakClassName="break-me"
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    containerClassName="pagination"
                                    subContainerClassName="pages pagination"
                                    activeClassName="active"
                                    pageCount={totalPage}
                                    forcePage={currentPage - 1}
                                    onPageChange={({ selected }) => {
                                        if (
                                            !isNaN(selected) &&
                                            selected !== currentPage - 1
                                        )
                                            getDownloads(selected + 1);
                                    }}
                                /> */}
                                <Pagination
                                    total={totalPage || 0}
                                    current={currentPage}
                                    pageSize={pageData?.limit || 10}
                                    showSizeChanger={false}
                                    showQuickJumper={false}
                                    onChange={(page) => {
                                        if (
                                            !isNaN(page) &&
                                            page !== currentPage
                                        ) {
                                            getDownloads(page);
                                        }
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    <div className="exportButton">
                        <span onClick={() => exportDownloadData()}>
                            {isExporting ? 'Exporting...' : 'Export'}
                        </span>
                    </div>
                </div>
            ) : (
                <div
                    className="visitorsCard"
                    style={{
                        height: '57px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '15px',
                        color: '#5f6e94',
                    }}
                >
                    {downloadsDataLoading ? (
                        <PageSpinner
                            type="Oval"
                            color="#ACBDC9"
                            height={48}
                            width={48}
                        />
                    ) : (
                        'No files downloaded'
                    )}
                </div>
            )}
            <Modal
                width={1200}
                title={
                    <p className="mb-0">
                        <small>
                            {' '}
                            Note: Max of 100 latest records will be displayed.
                            Export the data for the full set.
                        </small>
                    </p>
                }
                visible={modalVisibility}
                footer={null}
                onCancel={() => setModalVisibility(false)}
            >
                {detailUserDataLoading && isEmpty(detailUserData) && (
                    <PageSpinner
                        type="Oval"
                        color="#ACBDC9"
                        height={48}
                        width={48}
                    />
                )}
                {!isEmpty(detailUserData) && (
                    <>
                        <div style={{ maxHeight: 600, overflow: 'scroll' }}>
                            <Table borderless hover size="sm" responsive>
                                <thead>
                                    <tr>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Email</th>
                                        <th>Job Title</th>
                                        <th>Company</th>
                                        {livePageId === 'all' && <th>Page</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {detailUserData &&
                                        detailUserData?.map((item, index) => {
                                            let user = item.crowdflowUser;
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        {user?.firstname
                                                            ? user.firstname
                                                            : 'NA'}{' '}
                                                    </td>
                                                    <td>
                                                        {user?.lastname
                                                            ? user.lastname
                                                            : 'NA'}{' '}
                                                    </td>
                                                    <td>
                                                        {user?.email
                                                            ? user.email
                                                            : 'NA'}{' '}
                                                    </td>
                                                    <td>
                                                        {user?.jobTitle
                                                            ? user.jobTitle
                                                            : 'NA'}
                                                    </td>
                                                    <td>
                                                        {user?.company
                                                            ? user.company
                                                            : 'NA'}{' '}
                                                    </td>
                                                    {livePageId === 'all' && (
                                                        <td>
                                                            {item.livepageName ||
                                                                'NA'}
                                                        </td>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </Table>
                        </div>
                        <div className="exportButton">
                            <span
                                onClick={() => exportFetchUserData('Download')}
                            >
                                {isExporting ? 'Exporting...' : 'Export'}
                            </span>
                        </div>
                    </>
                )}
                {!detailUserDataLoading && isEmpty(detailUserData) && (
                    <p>There is no data</p>
                )}
            </Modal>
        </>
    );
};

const LinkClickList = ({
    enabledVenue,
    projectId,
    livePageId,
    startDate,
    endDate,
    isExportVisible,
    enableExport,
}) => {
    const [LinkData, setLinks] = useState([]);
    const [linksDataLoading, setLinksDataLoading] = useState(false);
    const [eventAction, setEventAction] = useState('');
    const [eventName, setEventName] = useState('');
    const [detailUserData, setDetailUserData] = useState([]);
    const [detailUserDataLoading, setDetailUserDataLoading] = useState(true);
    const [modalVisibility, setModalVisibility] = useState(false);
    const [pageData, setPagination] = useState({});
    const { totalPage, currentPage } = pageData;
    const [isExporting, setExporting] = useState(false);

    const getFetchUserData = async (
        category = 'Link',
        eventAction,
        eventName
    ) => {
        setEventAction(eventAction);
        setEventName(eventName);
        setDetailUserDataLoading(true);
        try {
            let { status, matomo } = await VisitorsAnalytics.getClickDetail(
                category,
                projectId,
                livePageId,
                moment(startDate).format('YYYY-MM-DD'),
                moment(endDate).format('YYYY-MM-DD'),
                eventAction,
                eventName,
                false
            );
            if (status && matomo && matomo.users && matomo.users.length > 0) {
                setDetailUserData(matomo.users);
                setDetailUserDataLoading(false);
            } else {
                setDetailUserData([]);
                setDetailUserDataLoading(false);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const exportFetchUserData = async (category = 'Link') => {
        try {
            if (!isExporting) {
                setExporting(true);
                const response = await VisitorsAnalytics.getClickDetail(
                    category,
                    projectId,
                    livePageId,
                    moment(startDate).format('YYYY-MM-DD'),
                    moment(endDate).format('YYYY-MM-DD'),
                    eventAction,
                    eventName,
                    true
                );
                FileSaver.saveAs(response, `ClickUsers.csv`);
                setExporting(false);
            }
        } catch (error) {
            console.error(error);
            setExporting(false);
        }
    };

    const getLinks = async (selPage = 1) => {
        setLinksDataLoading(true);
        try {
            let { status, matomo, pagination } =
                await VisitorsAnalytics.getLinkClicks(
                    projectId,
                    livePageId,
                    moment(startDate).format('YYYY-MM-DD'),
                    moment(endDate).format('YYYY-MM-DD'),
                    false,
                    selPage
                );
            if (status && matomo && matomo.links && matomo.links.length > 0) {
                setLinks(matomo.links);
                if (pagination) setPagination(pagination);
                if (!isExportVisible) enableExport();
            } else setLinks([]);
        } catch (error) {
            console.error(error);
        } finally {
            setLinksDataLoading(false);
        }
    };

    const exportLinkData = async () => {
        try {
            if (!isExporting) {
                setExporting(true);
                const response = await VisitorsAnalytics.getLinkClicks(
                    projectId,
                    livePageId,
                    moment(startDate).format('YYYY-MM-DD'),
                    moment(endDate).format('YYYY-MM-DD'),
                    true
                );
                FileSaver.saveAs(response, `${livePageId}LinkClicks.csv`);
                setExporting(false);
            }
        } catch (error) {
            console.error(error);
            setExporting(false);
        }
    };
    useEffect(() => {
        if (livePageId && startDate && endDate) {
            getLinks();
        }
    }, [livePageId, startDate, endDate]);

    return (
        <>
            {LinkData.length > 0 ? (
                <div style={{ marginBottom: '10px' }} className="visitorsCard">
                    <div className="visitorsTable">
                        <div
                            style={{
                                fontFamily: "'Open Sans'",
                                fontSize: '18px',
                                fontWeight: 'bold',
                                padding: '20px',
                                marginBottom: '-80px',
                            }}
                        >
                            What links did visitors click?
                        </div>
                        <Table borderless hover size="sm" responsive>
                            <thead>
                                <tr>
                                    <th>Label</th>
                                    <th>Url</th>
                                    <th>Total Clicks</th>
                                </tr>
                            </thead>
                            <tbody>
                                {LinkData.map(
                                    (
                                        {
                                            Events_EventAction,
                                            Events_EventName,
                                            nb_events,
                                        },
                                        index
                                    ) => {
                                        return (
                                            <tr
                                                key={index + Events_EventAction}
                                            >
                                                <td>
                                                    {Events_EventAction ?? 'NA'}
                                                </td>
                                                <td>
                                                    {Events_EventName ?? 'NA'}
                                                </td>
                                                <td>
                                                    {nb_events > 0 ? (
                                                        <a
                                                            style={{
                                                                color: 'blue',
                                                                textDecoration:
                                                                    'underline',
                                                            }}
                                                            onClick={() => {
                                                                getFetchUserData(
                                                                    'Link',
                                                                    Events_EventAction,
                                                                    Events_EventName
                                                                );
                                                                setModalVisibility(
                                                                    true
                                                                );
                                                            }}
                                                        >
                                                            {nb_events ?? '0'}
                                                        </a>
                                                    ) : (
                                                        nb_events ?? '0'
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    }
                                )}
                            </tbody>
                        </Table>
                        {totalPage && totalPage > 1 && (
                            <div className="paginationBar">
                                {/* <ReactPaginate
                                    previousLabel="prev"
                                    nextLabel="next"
                                    breakLabel="..."
                                    breakClassName="break-me"
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    containerClassName="pagination"
                                    subContainerClassName="pages pagination"
                                    activeClassName="active"
                                    pageCount={totalPage}
                                    forcePage={currentPage - 1}
                                    onPageChange={({ selected }) => {
                                        if (
                                            !isNaN(selected) &&
                                            selected !== currentPage - 1
                                        )
                                            getLinks(selected + 1);
                                    }}
                                /> */}
                                <Pagination
                                    total={totalPage || 0}
                                    current={currentPage}
                                    pageSize={pageData?.limit || 10}
                                    showSizeChanger={false}
                                    showQuickJumper={false}
                                    onChange={(page) => {
                                        if (
                                            !isNaN(page) &&
                                            page !== currentPage
                                        ) {
                                            getLinks(page);
                                        }
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    <div className="exportButton">
                        <span onClick={() => exportLinkData()}>
                            {isExporting ? 'Exporting...' : 'Export'}
                        </span>
                    </div>
                </div>
            ) : (
                <div
                    className="visitorsCard"
                    style={{
                        height: '57px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '15px',
                        color: '#5f6e94',
                    }}
                >
                    {linksDataLoading ? (
                        <PageSpinner
                            type="Oval"
                            color="#ACBDC9"
                            height={48}
                            width={48}
                        />
                    ) : (
                        'No links clicked'
                    )}
                </div>
            )}
            <Modal
                width={1200}
                title={
                    <p className="mb-0">
                        <small>
                            {' '}
                            Note: Max of 100 latest records will be displayed.
                            Export the data for the full set.
                        </small>
                    </p>
                }
                visible={modalVisibility}
                footer={null}
                onCancel={() => setModalVisibility(false)}
            >
                {detailUserDataLoading && isEmpty(detailUserData) && (
                    <PageSpinner
                        type="Oval"
                        color="#ACBDC9"
                        height={48}
                        width={48}
                    />
                )}

                {!isEmpty(detailUserData) && (
                    <>
                        <div style={{ maxHeight: 600, overflow: 'scroll' }}>
                            <Table borderless hover size="sm" responsive>
                                <thead>
                                    <tr>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Email</th>
                                        <th>Job Title</th>
                                        <th>Company</th>
                                        {livePageId === 'all' && <th>Page</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {detailUserData &&
                                        detailUserData?.map((item, index) => {
                                            let user = item.crowdflowUser;
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        {user?.firstname
                                                            ? user.firstname
                                                            : 'NA'}{' '}
                                                    </td>
                                                    <td>
                                                        {user?.lastname
                                                            ? user.lastname
                                                            : 'NA'}{' '}
                                                    </td>
                                                    <td>
                                                        {user?.email
                                                            ? user.email
                                                            : 'NA'}{' '}
                                                    </td>
                                                    <td>
                                                        {user?.jobTitle
                                                            ? user.jobTitle
                                                            : 'NA'}
                                                    </td>
                                                    <td>
                                                        {user?.company
                                                            ? user.company
                                                            : 'NA'}{' '}
                                                    </td>
                                                    {livePageId === 'all' && (
                                                        <td>
                                                            {item.livepageName ||
                                                                'NA'}
                                                        </td>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </Table>
                        </div>
                        <div className="exportButton">
                            <span onClick={() => exportFetchUserData('Link')}>
                                {isExporting ? 'Exporting...' : 'Export'}
                            </span>
                        </div>
                    </>
                )}
                {!detailUserDataLoading && isEmpty(detailUserData) && (
                    <p>There is no data</p>
                )}
            </Modal>
        </>
    );
};

const VisitorsList = ({
    enabledVenue,
    projectId,
    livePageId,
    startDate,
    endDate,
    isExportVisible,
    enableExport,
}) => {
    const [visitorsData, setVisitors] = useState([]);
    const [visitorsDataLoading, setVisitorsDataLoading] = useState(false);
    const [pageData, setPagination] = useState({});

    const getVisitors = async (selPage = 1) => {
        setVisitorsDataLoading(true);
        try {
            const { status, matomo, pagination } =
                await VisitorsAnalytics.getVisitorsList(
                    projectId,
                    livePageId,
                    moment(startDate).format('YYYY-MM-DD'),
                    moment(endDate).format('YYYY-MM-DD'),
                    false,
                    selPage
                );
            const response = await VisitorsAnalytics.getVisitors(
                projectId,
                livePageId,
                moment(startDate).format('YYYY-MM-DD'),
                moment(endDate).format('YYYY-MM-DD')
            );

            if (status && matomo && matomo.users && matomo.users.length > 0) {
                setVisitors(matomo.users);
                if (pagination) setPagination(pagination);

                if (!isExportVisible) enableExport();
            } else setVisitors([]);
        } catch (error) {
            console.error(error);
        } finally {
            setVisitorsDataLoading(false);
        }
    };
    const [isExporting, setExporting] = useState(false);
    const exportVisitorsData = async () => {
        try {
            if (!isExporting) {
                setExporting(true);
                const response = await VisitorsAnalytics.getVisitorsList(
                    projectId,
                    livePageId,
                    moment(startDate).format('YYYY-MM-DD'),
                    moment(endDate).format('YYYY-MM-DD'),
                    true
                );
                FileSaver.saveAs(response, `${livePageId}Visitors.csv`);
                setExporting(false);
            }
        } catch (error) {
            console.error(error);
            setExporting(false);
        }
    };
    const { totalPage, currentPage } = pageData;
    useEffect(() => {
        if (livePageId && startDate && endDate) {
            getVisitors();
        }
    }, [livePageId, startDate, endDate]);
    return (
        <>
            {visitorsData.length > 0 ? (
                <div className="visitorsCard">
                    <div className="visitorsTable">
                        <div
                            style={{
                                fontFamily: "'Open Sans'",
                                fontSize: '18px',
                                fontWeight: 'bold',
                                padding: '20px',
                                marginBottom: '-80px',
                            }}
                        >
                            Visitors List
                        </div>
                        <Table borderless hover size="sm" responsive>
                            <thead>
                                <tr>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Email</th>
                                    <th>Company</th>
                                    <th>Job Title</th>
                                    {livePageId === 'all' && <th>Page</th>}
                                    <th style={{ position: 'relative' }}>
                                        First Timestamp
                                        <Tooltip
                                            placement="topRight"
                                            title={`Time ${getDefaultTimeZone()}`}
                                        >
                                            <InfoCircleOutlined
                                                style={{
                                                    marginLeft: '5px',
                                                    position: 'absolute',
                                                }}
                                            />
                                        </Tooltip>
                                    </th>
                                    <th style={{ position: 'relative' }}>
                                        Last Timestamp
                                        <Tooltip
                                            placement="topRight"
                                            title={`Time ${getDefaultTimeZone()}`}
                                        >
                                            <InfoCircleOutlined
                                                style={{
                                                    marginLeft: '5px',
                                                    position: 'absolute',
                                                }}
                                            />
                                        </Tooltip>
                                    </th>
                                    <th>Visit Duration</th>
                                </tr>
                            </thead>
                            <tbody>
                                {visitorsData.map(
                                    (
                                        {
                                            crowdflowUser,
                                            firstActionTimestamp,
                                            lastActionTimestamp,
                                            visitDurationPretty,
                                            livepageName,
                                        },
                                        index
                                    ) => (
                                        <tr key={index}>
                                            <td>
                                                {crowdflowUser.firstname
                                                    ? crowdflowUser.firstname
                                                    : 'NA'}
                                            </td>
                                            <td>
                                                {crowdflowUser.lastname
                                                    ? crowdflowUser.lastname
                                                    : 'NA'}
                                            </td>
                                            <td>
                                                {crowdflowUser.email?.length > 0
                                                    ? crowdflowUser.email
                                                    : 'NA'}
                                            </td>
                                            <td>
                                                {crowdflowUser.company
                                                    ? crowdflowUser.company
                                                    : 'NA'}
                                            </td>
                                            <td>
                                                {crowdflowUser.jobTitle
                                                    ? crowdflowUser.jobTitle
                                                    : 'NA'}
                                            </td>
                                            {livePageId === 'all' && (
                                                <td>
                                                    {livepageName
                                                        ? livepageName
                                                        : 'NA'}
                                                </td>
                                            )}
                                            <td>
                                                {firstActionTimestamp
                                                    ? `${moment(
                                                          firstActionTimestamp
                                                      ).format(
                                                          'MMM D, YYYY h:mmA'
                                                      )}`
                                                    : 'NA'}
                                            </td>
                                            <td>
                                                {lastActionTimestamp
                                                    ? `${moment(
                                                          lastActionTimestamp
                                                      ).format(
                                                          'MMM D, YYYY h:mmA'
                                                      )}`
                                                    : 'NA'}
                                            </td>
                                            <td>
                                                {visitDurationPretty
                                                    ? visitDurationPretty
                                                    : 'NA'}
                                            </td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </Table>
                        {totalPage && totalPage > 1 && (
                            <div className="paginationBar">
                                {/* <ReactPaginate
                                    previousLabel="prev"
                                    nextLabel="next"
                                    breakLabel="..."
                                    breakClassName="break-me"
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    containerClassName="pagination"
                                    subContainerClassName="pages pagination"
                                    activeClassName="active"
                                    pageCount={totalPage}
                                    forcePage={currentPage - 1}
                                    onPageChange={({ selected }) => {
                                        if (
                                            !isNaN(selected) &&
                                            selected !== currentPage - 1
                                        )
                                            getVisitors(selected + 1);
                                    }}
                                /> */}
                                <Pagination
                                    total={totalPage || 0}
                                    current={currentPage}
                                    pageSize={pageData?.limit || 10}
                                    showSizeChanger={false}
                                    showQuickJumper={false}
                                    onChange={(page) => {
                                        if (
                                            !isNaN(page) &&
                                            page !== currentPage
                                        ) {
                                            getVisitors(page);
                                        }
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    <div className="exportButton">
                        <Tooltip placement="topRight" title="Get all records">
                            <span onClick={() => exportVisitorsData()}>
                                {isExporting ? 'Exporting...' : 'Export'}
                            </span>
                        </Tooltip>
                    </div>
                </div>
            ) : (
                <div
                    className="visitorsCard"
                    style={{
                        height: '57px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '15px',
                        color: '#5f6e94',
                    }}
                >
                    {visitorsDataLoading ? (
                        <PageSpinner
                            type="Oval"
                            color="#ACBDC9"
                            height={48}
                            width={48}
                        />
                    ) : (
                        'No users found'
                    )}
                </div>
            )}
        </>
    );
};

const getDefaultTimeZone = () => {
    try {
        const timezoneDate = new Date();
        const getzone = moment(timezoneDate)
            ?.tz(momentTimezone.tz.guess())
            ?.format('Z');
        const userZone = getzone === '+08:00' ? '+8' : getzone;
        return 'GMT' + userZone;
    } catch (error) {
        console.error(error);
        return '';
    }
};
export default class Visits extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEmpty: false,
            startDate: new Date(),
            endDate: new Date(),
            livePages: [],
            livePageId: '',
            livePageSearchText: '',
            livePageSearchOffset: 0,
            livePageTotal: 20,
            isExportVisible: false,
        };
        this.debouncedLivePageSearch = debounce(
            this.debouncedLivePageSearch,
            500
        );
    }
    componentDidMount() {
        this.fetchData('', 0).then(({ showcases, pagination, status }) => {
            if (status && showcases && showcases.length > 0) {
                this.setState({
                    livePages: showcases,
                    livePageId: 'all', // showcases[0].id,
                    livePageTotal: pagination?.total || 20,
                });
            } else {
                this.setState({ isEmpty: true });
            }
        });
    }
    componentDidUpdate(_prevProps, prevState) {
        if (this.state.livePageSearchText !== prevState.livePageSearchText) {
            this.setState({ livePageSearchOffset: 0 });
        }
        if (
            this.state.livePageSearchOffset !== prevState.livePageSearchOffset
        ) {
            this.debouncedLivePageSearch(this.state.livePageSearchText);
        }
    }
    enableExport = () => {
        this.setState({ isExportVisible: true });
    };
    debouncedLivePageSearch = async (livePageSearchText) => {
        try {
            this.setState({ loading: true });
            const { showcases, pagination } = await this.fetchData(
                livePageSearchText,
                this.state.livePageSearchOffset ?? 0
            );
            if (showcases && showcases.length > 0) {
                const currentLivePages =
                    livePageSearchText === this.state.livePageSearchText
                        ? [...this.state.livePages]
                        : [];
                let livePages = [...currentLivePages, ...showcases];
                livePages = uniqBy(livePages, 'id');
                this.setState({
                    livePages,
                    livePageTotal: pagination?.total || 20,
                    livePageSearchText,
                });
            } else {
                this.setState({
                    isEmpty: true,
                    livePageTotal: 20,
                    livePageSearchText,
                });
            }
        } catch (error) {
            console.error(error);
            this.setState({ livePageSearchText });
        } finally {
            this.setState({ loading: false });
        }
    };
    fetchData = async (search = '', offset = 0) => {
        try {
            const response = await getLivePages(
                this.props.projectId,
                'title',
                'asc',
                20,
                offset,
                search,
                []
            );
            if (response.status) {
                return {
                    showcases: response.showcases,
                    pagination: response.pagination,
                };
            } else throw new Error(response.message);
        } catch (error) {
            console.error(error);
            return { status: false, showcases: [], pagination: null };
        }
    };
    render() {
        return (
            <div className="visitorAnalysisContainer">
                {this.state.isExportVisible && (
                    <div className="visitorNote">
                        Note: Max of 100 latest records will be displayed.
                        Export the data for the full set.
                    </div>
                )}
                {this.state.livePages?.length > 0 ? (
                    <>
                        <div className="visitLiveBox controls">
                            <Select
                                id="visitsLivePageDrop"
                                placeholder="Select a livepage"
                                size="small"
                                showSearch={true}
                                optionFilterProp="data-search"
                                value={this.state.livePageId}
                                onChange={($event) => {
                                    this.setState({ livePageId: $event });
                                }}
                                onSearch={($event) => {
                                    this.debouncedLivePageSearch($event);
                                }}
                                autoClearSearchValue={false}
                                virtual={false}
                                getPopupContainer={(trigger) =>
                                    trigger.parentNode
                                }
                                loading={this.state.loading}
                                dropdownRender={(menu) => {
                                    return (
                                        <div>
                                            {menu}
                                            {this.state.livePages &&
                                                this.state.livePageTotal >
                                                    this.state.livePages
                                                        .length && (
                                                    <Fragment>
                                                        <Divider
                                                            style={{
                                                                margin: '4px 0',
                                                            }}
                                                        />
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                flexWrap:
                                                                    'nowrap',
                                                                padding:
                                                                    '2px 8px',
                                                                width: '100%',
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    backgroundColor:
                                                                        'rgba(0, 0, 0, 0.075)',
                                                                    textAlign:
                                                                        'center',
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                <Button
                                                                    type="link"
                                                                    htmlType="button"
                                                                    onClick={() => {
                                                                        this.setState(
                                                                            {
                                                                                livePageSearchOffset:
                                                                                    this
                                                                                        .state
                                                                                        .livePages
                                                                                        .length,
                                                                            }
                                                                        );
                                                                    }}
                                                                    disabled={
                                                                        this
                                                                            .state
                                                                            .loading
                                                                    }
                                                                    loading={
                                                                        this
                                                                            .state
                                                                            .loading
                                                                    }
                                                                    className="livepage-search-load-more-btn"
                                                                >
                                                                    Load more
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </Fragment>
                                                )}
                                        </div>
                                    );
                                }}
                                className="livepage-search"
                            >
                                <Select.OptGroup label="All Pages">
                                    <Select.Option
                                        key="all"
                                        value="all"
                                        data-search="All Pages"
                                    >
                                        All Pages
                                    </Select.Option>
                                </Select.OptGroup>
                                <Select.OptGroup label="Select Pages">
                                    {this.state.livePages?.map((livePage) => {
                                        return (
                                            <Select.Option
                                                key={livePage.id}
                                                value={livePage.id}
                                                data-search={
                                                    livePage.title +
                                                    livePage.slug
                                                }
                                            >
                                                {livePage.title}
                                            </Select.Option>
                                        );
                                    })}
                                </Select.OptGroup>
                            </Select>
                            <div className="visitor-live-page-search-tooltip">
                                <Tooltip
                                    placement="top"
                                    title="Search by your livepage URL slug"
                                >
                                    <InfoCircleOutlined
                                        style={{
                                            marginLeft: 24,
                                            position: 'absolute',
                                        }}
                                    />
                                </Tooltip>
                            </div>
                            <div className="visitorDate">
                                <DatePicker.RangePicker
                                    placeholder={['Start Date', 'End Date']}
                                    format="MMM D, YYYY"
                                    showTime={false}
                                    disabledDate={(current) => {
                                        return (
                                            current &&
                                            current > moment().startOf('day')
                                        );
                                    }}
                                    value={[
                                        moment(this.state.startDate).startOf(
                                            'day'
                                        ),
                                        moment(this.state.endDate).endOf('day'),
                                    ]}
                                    onChange={(dates) => {
                                        if (dates) {
                                            if (dates[0]) {
                                                this.setState({
                                                    startDate: dates[0]
                                                        .startOf('day')
                                                        .toDate(),
                                                });
                                            }
                                            if (dates[1]) {
                                                this.setState({
                                                    endDate: dates[1]
                                                        .endOf('day')
                                                        .toDate(),
                                                });
                                            }
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div
                            className="visitLiveBox"
                            style={{ marginTop: '10px' }}
                        >
                            <VisitorsList
                                {...{
                                    enabledVenue: this.props.enabledVenue,
                                    projectId: this.props.projectId,
                                    livePageId: this.state.livePageId,
                                    startDate: this.state.startDate,
                                    endDate: this.state.endDate,
                                    isExportVisible: this.state.isExportVisible,
                                    enableExport: this.enableExport,
                                }}
                            />
                        </div>
                        {!this.props.enabledVenue && (
                            <>
                                <div
                                    className="visitLiveBox"
                                    style={{ marginTop: '10px' }}
                                >
                                    <LinkClickList
                                        {...{
                                            enabledVenue:
                                                this.props.enabledVenue,
                                            projectId: this.props.projectId,
                                            livePageId: this.state.livePageId,
                                            startDate: this.state.startDate,
                                            endDate: this.state.endDate,
                                            isExportVisible:
                                                this.state.isExportVisible,
                                            enableExport: this.enableExport,
                                        }}
                                    />
                                </div>
                                <div
                                    className="visitLiveBox"
                                    style={{ marginTop: '10px' }}
                                >
                                    <DownloadClicksList
                                        {...{
                                            enabledVenue:
                                                this.props.enabledVenue,
                                            projectId: this.props.projectId,
                                            livePageId: this.state.livePageId,
                                            startDate: this.state.startDate,
                                            endDate: this.state.endDate,
                                            isExportVisible:
                                                this.state.isExportVisible,
                                            enableExport: this.enableExport,
                                        }}
                                    />
                                </div>
                            </>
                        )}
                    </>
                ) : this.state.isEmpty ? (
                    'No Data'
                ) : (
                    <PageSpinner
                        type="Oval"
                        color="#ACBDC9"
                        height={48}
                        width={48}
                    />
                )}
            </div>
        );
    }
}
